import IntegrationComponent from "../components/integrationcomponents/integrationcomponent"

const IntegrationPage = ()=>{
    return(
        <IntegrationComponent/>

    )
}

export default IntegrationPage